// extracted by mini-css-extract-plugin
export default {"wrap":"BacklotProductIllustrations_wrap__10xdP","svg":"BacklotProductIllustrations_svg__6dILa","shot":"BacklotProductIllustrations_shot__MBgoV"};